/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { TeamMatrixCategoryDto } from '../models';
// @ts-ignore
import type { TeamMatrixEmployeesResultDto } from '../models';
// @ts-ignore
import type { TeamMatrixResultDto } from '../models';
/**
 * TeamMatrixApi - axios parameter creator
 * @export
 */
export const TeamMatrixApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Feeds the \"Macierz zespołu\" tab. Returns all eight categories in one call: seven SevenFieldMatrix fields plus OUTSIDE_MDR for employees with no matrix field. Every category carries its own total (header counter) and its first page of employees. Page numbering is shared with /api/v2/team/matrix/employees for the same pageSize — the returned items are page 0, so the client resumes loading from page 1. 
         * @summary Matrix overview — first page of every MDR category at once (JAIN-477)
         * @param {number} pageSize 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTeamMatrix: async (pageSize: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('readTeamMatrix', 'pageSize', pageSize)
            const localVarPath = `/api/v2/team/matrix`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Loads further pages of one category behind the \"pokaż więcej\" action. Page numbering matches the overview endpoint for the same pageSize, so page 0 returns exactly what the overview already delivered. 
         * @summary Paginated employees of a single matrix category (JAIN-477)
         * @param {TeamMatrixCategoryDto} category Kategoria matrycy, której strona jest pobierana.
         * @param {number} pageSize 
         * @param {number} page 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeamMatrixEmployees: async (category: TeamMatrixCategoryDto, pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('searchTeamMatrixEmployees', 'category', category)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchTeamMatrixEmployees', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchTeamMatrixEmployees', 'page', page)
            const localVarPath = `/api/v2/team/matrix/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamMatrixApi - functional programming interface
 * @export
 */
export const TeamMatrixApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamMatrixApiAxiosParamCreator(configuration)
    return {
        /**
         * Feeds the \"Macierz zespołu\" tab. Returns all eight categories in one call: seven SevenFieldMatrix fields plus OUTSIDE_MDR for employees with no matrix field. Every category carries its own total (header counter) and its first page of employees. Page numbering is shared with /api/v2/team/matrix/employees for the same pageSize — the returned items are page 0, so the client resumes loading from page 1. 
         * @summary Matrix overview — first page of every MDR category at once (JAIN-477)
         * @param {number} pageSize 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readTeamMatrix(pageSize: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMatrixResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readTeamMatrix(pageSize, accessType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMatrixApi.readTeamMatrix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Loads further pages of one category behind the \"pokaż więcej\" action. Page numbering matches the overview endpoint for the same pageSize, so page 0 returns exactly what the overview already delivered. 
         * @summary Paginated employees of a single matrix category (JAIN-477)
         * @param {TeamMatrixCategoryDto} category Kategoria matrycy, której strona jest pobierana.
         * @param {number} pageSize 
         * @param {number} page 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTeamMatrixEmployees(category: TeamMatrixCategoryDto, pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMatrixEmployeesResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTeamMatrixEmployees(category, pageSize, page, accessType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMatrixApi.searchTeamMatrixEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamMatrixApi - factory interface
 * @export
 */
export const TeamMatrixApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamMatrixApiFp(configuration)
    return {
        /**
         * Feeds the \"Macierz zespołu\" tab. Returns all eight categories in one call: seven SevenFieldMatrix fields plus OUTSIDE_MDR for employees with no matrix field. Every category carries its own total (header counter) and its first page of employees. Page numbering is shared with /api/v2/team/matrix/employees for the same pageSize — the returned items are page 0, so the client resumes loading from page 1. 
         * @summary Matrix overview — first page of every MDR category at once (JAIN-477)
         * @param {number} pageSize 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTeamMatrix(pageSize: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamMatrixResultDto> {
            return localVarFp.readTeamMatrix(pageSize, accessType, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Loads further pages of one category behind the \"pokaż więcej\" action. Page numbering matches the overview endpoint for the same pageSize, so page 0 returns exactly what the overview already delivered. 
         * @summary Paginated employees of a single matrix category (JAIN-477)
         * @param {TeamMatrixCategoryDto} category Kategoria matrycy, której strona jest pobierana.
         * @param {number} pageSize 
         * @param {number} page 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeamMatrixEmployees(category: TeamMatrixCategoryDto, pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamMatrixEmployeesResultDto> {
            return localVarFp.searchTeamMatrixEmployees(category, pageSize, page, accessType, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamMatrixApi - interface
 * @export
 * @interface TeamMatrixApi
 */
export interface TeamMatrixApiInterface {
    /**
     * Feeds the \"Macierz zespołu\" tab. Returns all eight categories in one call: seven SevenFieldMatrix fields plus OUTSIDE_MDR for employees with no matrix field. Every category carries its own total (header counter) and its first page of employees. Page numbering is shared with /api/v2/team/matrix/employees for the same pageSize — the returned items are page 0, so the client resumes loading from page 1. 
     * @summary Matrix overview — first page of every MDR category at once (JAIN-477)
     * @param {number} pageSize 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMatrixApiInterface
     */
    readTeamMatrix(pageSize: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamMatrixResultDto>;

    /**
     * Loads further pages of one category behind the \"pokaż więcej\" action. Page numbering matches the overview endpoint for the same pageSize, so page 0 returns exactly what the overview already delivered. 
     * @summary Paginated employees of a single matrix category (JAIN-477)
     * @param {TeamMatrixCategoryDto} category Kategoria matrycy, której strona jest pobierana.
     * @param {number} pageSize 
     * @param {number} page 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMatrixApiInterface
     */
    searchTeamMatrixEmployees(category: TeamMatrixCategoryDto, pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamMatrixEmployeesResultDto>;

}

/**
 * TeamMatrixApi - object-oriented interface
 * @export
 * @class TeamMatrixApi
 * @extends {BaseAPI}
 */
export class TeamMatrixApi extends BaseAPI implements TeamMatrixApiInterface {
    /**
     * Feeds the \"Macierz zespołu\" tab. Returns all eight categories in one call: seven SevenFieldMatrix fields plus OUTSIDE_MDR for employees with no matrix field. Every category carries its own total (header counter) and its first page of employees. Page numbering is shared with /api/v2/team/matrix/employees for the same pageSize — the returned items are page 0, so the client resumes loading from page 1. 
     * @summary Matrix overview — first page of every MDR category at once (JAIN-477)
     * @param {number} pageSize 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMatrixApi
     */
    public readTeamMatrix(pageSize: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return TeamMatrixApiFp(this.configuration).readTeamMatrix(pageSize, accessType, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Loads further pages of one category behind the \"pokaż więcej\" action. Page numbering matches the overview endpoint for the same pageSize, so page 0 returns exactly what the overview already delivered. 
     * @summary Paginated employees of a single matrix category (JAIN-477)
     * @param {TeamMatrixCategoryDto} category Kategoria matrycy, której strona jest pobierana.
     * @param {number} pageSize 
     * @param {number} page 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMatrixApi
     */
    public searchTeamMatrixEmployees(category: TeamMatrixCategoryDto, pageSize: number, page: number, accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return TeamMatrixApiFp(this.configuration).searchTeamMatrixEmployees(category, pageSize, page, accessType, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

